<template>


  <div class='myTile'>
    <p class='title is-3 is-6-mobile'>bots are evil</p>
    <div class='has-text-left'>
      <p>That said, there were a handful of super-spreaders who infected hundreds of users. In this case, they were mostly bots.</p>
      <br>
      <p class='chartTitle'>Table 1:  Users responsible for most infections
      <hr class='rule'>

      <table class='table is-fullwidth '>
        <thead>
          <tr>
            <th>user</th>
            <th>number infected</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(numInfected, spreader) in superSpreaders" :key="spreader">
            <td class='userName is-size-6-mobile'>{{ spreader }}</td>
            <td class='myNumber is-size-6-mobile'>{{ numInfected }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        superSpreaders: {
          'RepostSleuthBot': '3,311',
          'AutoModerator': '2,028',
          'fualtyzane': '1,171',
          // 'Xploiter_RBLX': ,
          // 'racerfree': 
        },
      }
    }
  }
  
</script>

<style scoped>
  .table {
    background-color: #F0F0F0;
  }
</style>
